// تشخیص محیط توسعه (Local) از محیط عملیاتی (Production)
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// اگر در لوکال هستیم، به سرور اصلی وصل شو، در غیر این صورت از آدرس نسبی استفاده کن
const BASE_URL = isDevelopment 
  ? "https://sfarm.tabangohar.com/api" 
  : "/api";

export const request = async (endpoint, method = 'GET', body = null) => {
  const token = localStorage.getItem('token');
  
  // اطمینان از اینکه endpoint با / شروع می‌شود
  const safeEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  const headers = {
    'Content-Type': 'application/json',
  };

  // اضافه کردن توکن Bearer اگر موجود باشد
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const config = {
    method,
    headers,
  };

  // اضافه کردن بادی فقط برای متدهای غیر GET
  if (body && method !== 'GET') {
    config.body = JSON.stringify(body);
  }

  try {
    const response = await fetch(`${BASE_URL}${safeEndpoint}`, config);
    
    // مدیریت انقضای توکن (۴۰۱ یعنی نشست کاربر تمام شده)
    if (response.status === 401) {
      localStorage.removeItem('token');
      // جلوگیری از ریدایرکت مکرر اگر در صفحه لاگین هستیم
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
      return;
    }

    // بررسی اینکه آیا پاسخ معتبر است
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("🔴 API Request Failed:", error);
    throw error;
  }
};